export enum MobileEvents {
  loadComplete = 'loadcomplete',
  openEpisode = 'openEpisode',
  openUserProfile = 'openUserProfile',
  openStarProfile = 'openStarProfile',
  openShowDetails = 'openShowDetails',
  openVideo = 'openVideo',
  openPlayer = 'openPlayer',
  openPlaylist = 'openPlaylist',
  openFilmmaker = 'openFilmmaker',
  openChannel = 'openChannel',
  openUrl = 'openUrl',
  openRecommendedUsersByPost = 'openRecommendedUsersByPost',
  openAuth = 'openAuth',
  openSubscribe = 'openSubscribe',
  openProfilePage = 'openProfilePage',
  openPost = 'openPost',
  postDetails = 'postDetails',
  emptyPosts = 'emptyPosts',
  tokenUpdated = 'tokenUpdated',
  openFlixsnipVideo = 'openFlixsnipVideo',
  goBack = 'goBack',
}
